import * as actionTypes from './actionTypes';
import { CategoryModel } from '@app/src/views/Home/listProducts';

interface State {
  data: CategoryModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const categories = (state = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
